export function isWindowExists() {
  return typeof window !== 'undefined';
}

export function isLifeCycleEventExists() {
  return isWindowExists() && window.LIFE_CYCLE_EVENT_BUS;
}
